// core/interceptors/loading.interceptor.ts
import { inject } from '@angular/core';
import { HttpInterceptorFn } from '@angular/common/http';
import { finalize, timeout } from 'rxjs/operators';
import { GlobalLoadingService } from '../services/loading.service';
import { LOADER_OPTS, SKIP_GLOBAL_LOADER } from './loader.tokens';

export const loadingInterceptor: HttpInterceptorFn = (req, next) => {
  const loading = inject(GlobalLoadingService);
  const skip = req.context.get(SKIP_GLOBAL_LOADER);
  const opts = req.context.get(LOADER_OPTS); // label only

  if (!skip) loading.start({ label: opts.label });

  return next(req).pipe(
    timeout({ each: 60000 }),
    finalize(() => { if (!skip) loading.stop(); })
  );
};
